// 法的文書（利用規約・プライバシーポリシー等）で共有する運営者情報。
// 運営者名は VRMA Hub Project。問い合わせ・個人情報の開示等請求・権利侵害の申告は
// すべてサイト内の問い合わせフォーム（/contact）経由に一本化し、
// パブリックなメールアドレスはサイト上に掲示しない方針。
//
// 補足（日本の法令）:
// - 一般利用者向けのアップロード・公開・閲覧機能、開発者向け API（月間 50,000 リクエストまで）は
//   いずれも無料で提供する。有償サービスの提供が無いため、特定商取引法に基づく表記は掲載しない
//   （`Operator.tsx` は運営者情報のみを掲載する）。
// - 月間無料枠を超える API の継続利用が必要な場合は、下記 contactPath（問い合わせフォーム）
//   から運営者に連絡し、個別に協議・合意した条件で対応する。
// - 個人情報保護法に基づく「開示等の請求」窓口と、権利侵害の申告窓口も
//   同じく contactPath（問い合わせフォーム）に一本化する。
export const OPERATOR = {
  serviceName: 'VRMA Hub',
  // 運営者名。開示等の請求への回答時に本人性確認の基準となる。
  operatorName: 'VRMA Hub Project',
  // 屋号（任意）。なければ空文字で可。
  tradeName: '',
  // サイト内問い合わせフォームへのパス。問い合わせ・個人情報の開示等請求・権利侵害の申告の共通窓口。
  contactPath: '/contact',
  // 問い合わせフォームへのリンクの表示テキスト。
  contactLabel: 'お問い合わせフォーム',
  // 準拠法上の第一審の専属的合意管轄。運営者の住所地を管轄する裁判所を記載。
  jurisdiction: '東京地方裁判所（第一審の専属的合意管轄）',
  // データの主たる保管場所（AWS リージョン）。
  region: '日本国内（Amazon Web Services 東京リージョン / ap-northeast-1）',
  // サービスはリリース前のため「改定」ではなく初版（制定）として扱う。
  effectiveDate: '2026年7月31日',
} as const;
